import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'spw-field-label',
  styleUrl: 'spw-field-label.scss',
  shadow: true,
})
export class SpwFieldLabel {
  /** L'attribut id de l'élément input */
  @Prop() name: string;
  /** Texte à afficher au-dessus du champ de saisie */
  @Prop() label?: string = '';
  /** Indique si le champ est requis */
  @Prop() required?: boolean = false;

  @Element() el: HTMLSpwFieldLabelElement;

  private handleClick = () => {
    const rootNode = this.el.getRootNode() as ShadowRoot | Document;
    const targetElement = rootNode.getElementById(this.name);

    if (targetElement) {
      (targetElement as HTMLElement).focus();
    }
  };

  render() {
    return (
      <Host>
        <label class="spw-field-label" htmlFor={this.name} onClick={this.handleClick}>
          {this.label} {this.required && <span class="spw-field-label__required">*</span>}
        </label>
      </Host>
    );
  }
}
